<template>
  <div class="order-statistic">
    <el-card>
      <el-form :label-position="labelPosition" :model="formLabelAlign" label-width="60px">
        <el-form-item label="供应商">
          <el-tag-selector
            :dynamic-tags="formLabelAlign.providers"
            :selectors="selectors"
          />
        </el-form-item>
        <el-form-item label="类型:">
          <el-checkbox-group :min="1" v-model="formLabelAlign.type" @change="changHandler">
            <el-checkbox label="企业订单" name="type"/>
            <el-checkbox label="个人订单" name="type"/>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="专区:">
          <el-checkbox-group :min="1" v-model="formLabelAlign.region" @change="changHandler">
            <el-checkbox label="电子超市" name="region"/>
            <el-checkbox label="工程专区" name="region"/>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </el-card>
    <br>
    <el-card id="print-box" class="print-export">
      <div>
        <el-table
          :header-cell-style="{background:'#ffffff',color:'#4A4A4A'}"
          :data="tableData"
          :summary-method="getSummaries"
          style="width: 100%"
          row-key="id"
          show-summary
          border
          class="report multi-header"
          @row-click="jumpToDetail">
          <el-table-column
            prop="id"
            label="序号"
            width="43"/>
          <el-table-column
            prop="name"
            label="采购单位/经办部门"
            width="244"/>
          <el-table-column
            prop="type"
            label="类型"
            width="130"
          />
          <el-table-column
            :label="formLabelAlign.region.join('/')"
            prop="number"
            width="660"
          >
            <el-table-column

              label="本周">
              <el-table-column
                prop="weekCount"
                label="订单数(个)"/>
              <el-table-column
                prop="weekAmount"
                label="订单金额(元)"/>
            </el-table-column>
            <el-table-column
              label="本月">
              <el-table-column
                prop="monthCount"
                label="订单数(个)"/>
              <el-table-column
                prop="monthAmount"
                label="订单金额(元)"/>
            </el-table-column>
            <el-table-column
              label="本年">
              <el-table-column
                prop="yearCount"
                label="订单数(个)"/>
              <el-table-column
                prop="yearAmount"
                label="订单金额(元)"/>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>

    </el-card>
    <br>
    <br>
    <br>
    <br>
    <el-bottom-print-export/>
  </div>
</template>

<script>
// import Breadcrumb from '@/components/Breadcrumb'
// import { getList } from '@/api/order-statistic'
import ExcelJS from 'exceljs/dist/es5/exceljs.browser'
import { saveAs } from 'file-saver'

export default {
  name: 'OrderStatistic',
  components: {
    Breadcrumb
  },
  data() {
    return {
      pageNo: 4,
      pageSize: 10,
      labelPosition: 'right',
      formLabelAlign: {
        providers: ['京东', '震坤行'],
        type: ['企业订单', '个人订单'],
        region: ['电子超市', '工程专区']
      },
      tableData: [],
      selectors: [{
        value: '京东',
        label: '京东'
      }, {
        value: '震坤行',
        label: '震坤行'
      }, {
        value: '天猫',
        label: '天猫'
      }, {
        value: '聚划算',
        label: '聚划算'
      }, {
        value: '天天特价',
        label: '天天特价'
      }, {
        value: '五一特惠',
        label: '五一特惠'
      }]
    }
  },
  watch: {
    formLabelAlign: {
      handler(newVul, oldVul) {
        // console.log(newVul)
        this.getList()
      },
      deep: true
    }
  },
  activated() {
    this.getList()
  },
  methods: {
    jumpToDetail(row, col, e) {
      console.log('wwwwwwwwwww')
      console.log(row)
      console.log(col)
      console.log(e)
      if (row.id) {
        this.$router.push('/statistic/order/purchaser/order-detail/' + row.id)
      } else {
        this.$message('查看详情请点击有序号的行')
      }
    },
    changHandler() {
      this.getList()
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] += ' 元'
        } else {
          sums[index] = '-'
        }
      })

      return sums
    },
    getList() {
      this.tableData = []
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      }
      getList(obj).then(res => {
        const arr = res.data.data
        this.addItem(arr)
        this.tableData = arr
      })
    },
    addItem(arr) {
      if (arr.length < 10) {
        arr.push({})
        this.addItem(arr)
      }
    },
    async saveAsExcel() {
      const wb = new ExcelJS.Workbook()
      const ws1 = wb.addWorksheet('交建第一页')
      const page1Row1 = ws1.addRow(['a', 'b', 'c'])
      ws1.addRow([' aa', 'bb', 'bb'])
      ws1.addRow(['  aaa', 'bbb', 'ccc'])
      console.log('page1Row1')
      console.log(page1Row1)
      page1Row1.font = { bold: true, color: { argb: '00489A' }}
      page1Row1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' }
      }
      const ws2 = wb.addWorksheet('交建第二页')
      const page2Row1 = ws2.addRow(['a', 'b', 'c'])
      page2Row1.font = { bold: true, color: { argb: 'FFF000' }}
      const buf = await wb.xlsx.writeBuffer()
      saveAs(new Blob([buf]), 'abc.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped>
  .order-statistic {
    .el-form-item {
      margin-bottom: 0;
    }

  }
</style>
